import * as React from "react";
import type { SVGProps } from "react";
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#facebook_svg__a)">
      <path
        fill="currentColor"
        d="M13 22H9a1 1 0 0 1-1-1v-6H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2V8a6 6 0 0 1 6-6h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3v1h3a1 1 0 0 1 .79.38 1 1 0 0 1 .18.86l-1 4A1 1 0 0 1 16 15h-2v6a1 1 0 0 1-1 1m-3-2h2v-6a1 1 0 0 1 1-1h2.22l.5-2H13a1 1 0 0 1-1-1V8a2 2 0 0 1 2-2h2V4h-2a4 4 0 0 0-4 4v2a1 1 0 0 1-1 1H7v2h2a1 1 0 0 1 1 1z"
      />
    </g>
    <defs>
      <clipPath id="facebook_svg__a">
        <path fill="#fff" d="M5 2h13v20H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFacebook;
